// The one screen a TOTP-held account is allowed to reach. Shared because the
// interceptor navigates here and the role guard has to let it through -- two
// copies of a path that must match is how the hold became unclearable once.
export const TOTP_ENROLMENT_ROUTE = '/security/two-factor-auth';

// The exact body `VerifyTfa` returns while the hold is on. Everything except
// verify_tfa and totp/* 403s with it.
export const TOTP_ENROLMENT_REQUIRED = 'TOTP enrolment required';
